import React from 'react';
import './app-headsup.css'
import { withTranslation } from 'react-i18next';

class AppHeadsup extends React.Component {
  element;
  count = 0;

  componentDidLoad() {
    this.element.classList.add('animation-enabled');
  }

  render() {
    const { t } = this.props;
    const countRender = this.count > 1 ? this.count : 1;

    return (
      <div className="app-headsup animation-enabled">
        <span className="count">{countRender}</span>
        <span className="message">{t('chat.newMessagesCounter', '{{count}} nya meddelanden', { count: countRender })}</span>
      </div>
    );
  }
}

export default withTranslation('users')(AppHeadsup);
